import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const WatercolorTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  const waterGradId = 'water-tmpl-heart-grad';
  const textGradId = 'water-tmpl-text-grad';

  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(135deg, #fef5e7 0%, #fff9f0 30%, #fef0f0 60%, #f0f8ff 100%)',
        overflow: 'hidden', fontFamily: 'Arial, sans-serif',
        position: 'relative', boxSizing: 'border-box'
      }}
    >
      {/* 隱藏 SVG defs */}
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <linearGradient id={waterGradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffb6c1" />
            <stop offset="50%" stopColor="#ffc0cb" />
            <stop offset="100%" stopColor="#dda0dd" />
          </linearGradient>
          <linearGradient id={textGradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#d8a7b1" />
            <stop offset="50%" stopColor="#b88ea8" />
            <stop offset="100%" stopColor="#a8829f" />
          </linearGradient>
        </defs>
      </svg>

      {/* 水彩暈染效果 */}
      <div style={{ position: 'absolute', top: '5%', left: '5%', width: '450px', height: '450px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,182,193,0.25) 0%, rgba(255,182,193,0.05) 50%, transparent 70%)', filter: 'blur(60px)' }} />
      <div style={{ position: 'absolute', top: '15%', right: '8%', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,218,224,0.3) 0%, rgba(255,218,224,0.08) 50%, transparent 70%)', filter: 'blur(70px)' }} />
      <div style={{ position: 'absolute', bottom: '10%', left: '10%', width: '420px', height: '420px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(230,230,250,0.28) 0%, rgba(230,230,250,0.06) 50%, transparent 70%)', filter: 'blur(65px)' }} />
      <div style={{ position: 'absolute', bottom: '20%', right: '12%', width: '380px', height: '380px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,240,245,0.35) 0%, rgba(255,240,245,0.1) 50%, transparent 70%)', filter: 'blur(55px)' }} />

      {/* 紙張質感 */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 4px, rgba(0,0,0,0.008) 4px, rgba(0,0,0,0.008) 8px)', opacity: 0.4 }} />

      {/* 主內容區 */}
      <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: '80px 80px 65px 80px', boxSizing: 'border-box' }}>

        {/* 頂部愛心 */}
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <div style={{ display: 'inline-block', padding: '30px', background: 'radial-gradient(circle, rgba(255,192,203,0.2), rgba(255,192,203,0.05))', borderRadius: '50%', border: '3px solid rgba(255,182,193,0.3)', boxShadow: '0 10px 40px rgba(255,182,193,0.2)' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" viewBox="0 0 24 24">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill={`url(#${waterGradId})`} opacity="0.85" />
            </svg>
          </div>
        </div>

        {/* 中間內容 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>

          {/* 主數字 — SVG 漸變文字 */}
          <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="920" height="220" viewBox="0 0 920 220">
              <defs>
                <linearGradient id={`${textGradId}-num`} x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#d8a7b1" />
                  <stop offset="50%" stopColor="#b88ea8" />
                  <stop offset="100%" stopColor="#a8829f" />
                </linearGradient>
              </defs>
              <text x="50%" y="85%" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="200" fill={`url(#${textGradId}-num)`}>
                {calculatedDays}
              </text>
            </svg>
          </div>

          <div style={{ fontSize: '46px', fontWeight: '600', color: '#b88ea8', marginBottom: '35px', opacity: 0.85 }}>
            {language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}
          </div>

          {detailedTime && (
            <div style={{ display: 'inline-block', fontSize: '35px', color: '#9b7fa6', fontWeight: '500', marginBottom: '40px', padding: '20px 50px', background: 'rgba(255,240,245,0.6)', border: '2.5px solid rgba(255,182,193,0.4)', borderRadius: '55px', boxShadow: '0 8px 30px rgba(255,182,193,0.15)', alignSelf: 'center' }}>
              {formatDetailedTime(detailedTime, language)}
            </div>
          )}

          {quote && (
            <div style={{ fontSize: '29px', color: '#a8829f', fontStyle: 'italic', lineHeight: '1.6', maxWidth: '720px', margin: '0 auto 30px auto', opacity: 0.8 }}>
              "{quote}"
            </div>
          )}
        </div>

        {/* 底部信息 */}
        <div style={{ textAlign: 'center', paddingTop: '35px', paddingBottom: '28px', background: 'rgba(255,240,245,0.5)', border: '3px solid rgba(255,182,193,0.3)', borderRadius: '28px', boxShadow: '0 10px 40px rgba(255,182,193,0.12)' }}>
          {anniversaryDate && (<div style={{ fontSize: '28px', color: '#b88ea8', marginBottom: '15px', opacity: 0.85 }}>{formatDate(anniversaryDate, language)}</div>)}
          <div style={{ fontSize: '33px', fontWeight: '700', color: '#d8a7b1', textTransform: 'uppercase', letterSpacing: '2.5px', marginBottom: '12px' }}>{getBrandingText(anniversaryType, language)}</div>
          <div style={{ fontSize: '24px', color: '#a8829f', opacity: 0.8 }}>lovedays.homy.hk</div>
        </div>
      </div>
    </div>
  );
};

export default WatercolorTemplate;